module.exports = __webpack_public_path__ + "media/markers/marker-cluster-light-blue-1acb689c.svg";